import { stringify } from "../../util/querystring-util";
import { restResourceRequester } from "../rest-resource-requester";
import { GetDataKindRequest } from "./get-data-kind/GetDataKindRequest";
import { GetDataKindResponse } from "./get-data-kind/GetDataKindResponse";
import { PutDataKindRequest } from "./put-data-kind/PutDataKindRequest";
import { PutDataKindResponse } from "./put-data-kind/PutDataKindResponse";

interface DataKindsRestResource {
  getDatakind(request: GetDataKindRequest): Promise<GetDataKindResponse>;
  putDatakind(request: PutDataKindRequest): Promise<PutDataKindResponse>;
}

const REST_RESOURCE_NAME = {
  DATA_KINDS: "/data-kinds",
};

/**
 * GET /get-data-kind
 */
const getDatakind = restResourceRequester<
  GetDataKindRequest,
  GetDataKindResponse
>("GET", (request) => {
  if (request.dfnSetVerNum) {
    const queryParameters = {
      dfnSetVerNum: request.dfnSetVerNum,
    };
    return `${REST_RESOURCE_NAME.DATA_KINDS}?${stringify(queryParameters)}`;
  } else {
    return REST_RESOURCE_NAME.DATA_KINDS;
  }
});

/**
 * PUT /put-data-kind
 */
const putDatakind = restResourceRequester<
  PutDataKindRequest,
  PutDataKindResponse
>(
  "PUT",
  (request) => {
    return `${REST_RESOURCE_NAME.DATA_KINDS}`;
  },
  (request) => JSON.stringify(request),
);

export const dataKindsRestResource: DataKindsRestResource = {
  getDatakind: getDatakind,
  putDatakind: putDatakind,
};
